import { Text, Box } from '@usap/uicomponents'
import styled from 'styled-components'

export const TextWithStyle = styled(Text)`
  cursor: ${({ noPointer = false }) => (noPointer ? 'unset' : 'pointer')};
`

export const BreadCrumbBox = styled(Box)`
  padding: 0 8px;
  margin: 16px auto;
  display: flex;
  box-sizing: border-box;
  flex-flow: wrap;
  width: 100%;

  &.breadCrumbListScrollable{
    overflow-x: scroll;
    white-space: nowrap;
    display: inline-block;
    margin: 16px auto;
  }

  &.breadCrumbListScrollable li{
    display: inline-flex;
  }
 
  &.breadCrumbListScrollable::-webkit-scrollbar {
    display: none;
  }
`;
